import {
    CREATE_FABRIC_PO_MASTER_REQUEST,
    CREATE_FABRIC_PO_MASTER_SUCCESS,
    CREATE_FABRIC_PO_MASTER_FAILURE,
    DELETE_FABRIC_PO_MASTER_REQUEST,
    DELETE_FABRIC_PO_MASTER_SUCCESS,
    DELETE_FABRIC_PO_MASTER_FAILURE,
    FETCH_SINGLE_FABRIC_PO_MASTER_REQUEST,
    FETCH_SINGLE_FABRIC_PO_MASTER_SUCCESS,
    FETCH_SINGLE_FABRIC_PO_MASTER_FAILURE,
    FETCH_FABRIC_PO_MASTER_REQUEST,
    FETCH_FABRIC_PO_MASTER_SUCCESS,
    FETCH_FABRIC_PO_MASTER_FAILURE,
    UPDATE_FABRIC_PO_MASTER_REQUEST,
    UPDATE_FABRIC_PO_MASTER_SUCCESS,
    UPDATE_FABRIC_PO_MASTER_FAILURE,
    RESET_FABRIC_PO_MASTER_INFO,
    CREATE_FABRIC_PO_MASTER_FORM,
    UPDATE_FABRIC_PO_MASTER_FORM,
    NAVIGATE_FABRIC_PO_DETAILS,
    NAVIGATE_FABRIC_PO_MASTER,
    FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_SUCCESS,
    FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_FAILURE,
    FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_REQUEST,
    FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    FETCH_FABRIC_PO_INVOICE_REQUEST,
    FETCH_FABRIC_PO_INVOICE_SUCCESS,
    FETCH_FABRIC_PO_INVOICE_FAILURE,
    RESET_FABRIC_PO_INVOICE,
    UPDATE_FABRIC_PO_SUCCESS,
    UPDATE_FABRIC_PO_REQUEST,
    UPDATE_FABRIC_PO_FAILURE,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_FABRIC_PO_PRINT
} from './fabricPoMaster.actionsType';

export const FABRIC_PO_MASTER = 'fabricPoMaster';

let initialState = {
    loading: false,
    fabricPoMaster: [],
    fabricPoInvoiceV2: [],
    fabricPoMasterForm: {
        fldFKDeliveryAt: '', fldFKSupplierID: '', fldIsInHouseDelivery: false, FldIsGenerateStyleWise: false,
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1
    },
    selectedState: {},
    typeOfPoList: [],
    sourceList: [],
    departmentList: [],
    deliveryAt: [],
    generalItemList: [],
    generalHeaderList: [],
    uomList: [],
    errorMessage: '',
    singleFabricPoData: {},
    isFabricPoDetails: false,
    detailsId: '',
    activeKey: 1,
    headerSearchCall: true,
};

export let fabricPoMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_FABRIC_PO_MASTER_REQUEST:
        case FETCH_FABRIC_PO_INVOICE_REQUEST:
        case CREATE_FABRIC_PO_MASTER_REQUEST:
        case UPDATE_FABRIC_PO_MASTER_REQUEST:
        case FETCH_SINGLE_FABRIC_PO_MASTER_REQUEST:
        case DELETE_FABRIC_PO_MASTER_REQUEST:
        case FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_REQUEST:
        case UPDATE_FABRIC_PO_REQUEST:
            return {
                ...state,
                loading: true
            };

        case FETCH_FABRIC_PO_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricPoMaster: updatePayload
            };
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }
        case NAVIGATE_FABRIC_PO_PRINT:
            return {
                ...state,
                loading: false,
                singleFabricPoData: updatePayload.singleFabricPoData
            }
        case FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_SUCCESS:
            if (payload == 52) {
                return {
                    ...state,
                    loading: false,
                    typeOfPoList: updatePayload
                };
            } else if (payload == 46) {
                return {
                    ...state,
                    loading: false,
                    sourceList: updatePayload
                };
            } else if (payload == 28) {
                return {
                    ...state,
                    loading: false,
                    departmentList: updatePayload
                };
            } else if (payload == 53) {
                return {
                    ...state,
                    loading: false,
                    deliveryAt: updatePayload
                };
            } else if (payload == 22) {
                return {
                    ...state,
                    loading: false,
                    uomList: updatePayload
                };
            } else if (payload == 53) {
                return {
                    ...state,
                    loading: false,
                    generalHeaderList: updatePayload
                };
            } else if (payload == 53) {
                return {
                    ...state,
                    loading: false,
                    generalItemList: updatePayload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case CREATE_FABRIC_PO_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricPoMasterForm: {
                    fldFKDeliveryAt: '', fldFKSupplierID: '', fldIsInHouseDelivery: false, FldIsGenerateStyleWise: false,
                    startDate: state.fabricPoMasterForm.startDate,
                    endDate: state.fabricPoMasterForm.endDate,
                    unitId: state.fabricPoMasterForm.unitId
                },
                detailsId: updatePayload
            };
        case UPDATE_FABRIC_PO_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricPoMasterForm: {
                    fldFKDeliveryAt: '', fldFKSupplierID: '', fldIsInHouseDelivery: false, FldIsGenerateStyleWise: false,
                    startDate: state.fabricPoMasterForm.startDate,
                    endDate: state.fabricPoMasterForm.endDate,
                    unitId: state.fabricPoMasterForm.unitId
                },
                detailsId: ''
            };
        case UPDATE_FABRIC_PO_SUCCESS: {
            return {
                ...state,
                loading: false,
                updatedList: updatePayload
            };
        }
        case FETCH_SINGLE_FABRIC_PO_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricPoMasterForm: {
                    ...updatePayload,
                    startDate: state.fabricPoMasterForm.startDate,
                    endDate: state.fabricPoMasterForm.endDate,
                    unitId: state.fabricPoMasterForm.unitId
                }
            };
        case FETCH_FABRIC_PO_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricPoInvoiceV2: updatePayload
            };
        case DELETE_FABRIC_PO_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricPoMasterForm: { fldFKDeliveryAt: '', fldFKSupplierID: '', fldIsInHouseDelivery: false, FldIsGenerateStyleWise: false },
                detailsId: ''
            };
        case RESET_FABRIC_PO_MASTER_INFO:
            return {
                ...state,
                fabricPoMasterForm: {
                    fldFKDeliveryAt: '', fldFKSupplierID: '', fldIsInHouseDelivery: false, FldIsGenerateStyleWise: false,
                    startDate: state.fabricPoMasterForm.startDate,
                    endDate: state.fabricPoMasterForm.endDate,
                    unitId: state.fabricPoMasterForm.unitId
                },
                detailsId: '',
                activeKey: 1
            };
        case CREATE_FABRIC_PO_MASTER_FORM:
        case UPDATE_FABRIC_PO_MASTER_FORM:
            return {
                ...state,
                loading: false,
                fabricPoMasterForm: {
                    ...state.fabricPoMasterForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_FABRIC_PO_MASTER_FAILURE:
        case FETCH_FABRIC_PO_INVOICE_FAILURE:
        case CREATE_FABRIC_PO_MASTER_FAILURE:
        case UPDATE_FABRIC_PO_MASTER_FAILURE:
        case FETCH_SINGLE_FABRIC_PO_MASTER_FAILURE:
        case DELETE_FABRIC_PO_MASTER_FAILURE:
        case FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_FAILURE:
        case UPDATE_FABRIC_PO_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_FABRIC_PO_DETAILS:
            return {
                ...state,
                isFabricPoDetails: true,
                singleFabricPoData: updatePayload.singleFabricPoData
            };
        case NAVIGATE_FABRIC_PO_MASTER:
            return {
                ...state,
                isFabricPoDetails: false
            };
        case RESET_FABRIC_PO_INVOICE:
            return {
                ...state,
                fabricPoInvoiceV2: []
            };
        case FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                fabricPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    FldIsGenerateStyleWise: false,
                    startDate: state.fabricPoMasterForm.startDate,
                    endDate: state.fabricPoMasterForm.endDate,
                    unitId: state.fabricPoMasterForm.unitId
                },
                activeKey: 2
            };
        case FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                fabricPoMasterForm: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    FldIsGenerateStyleWise: false,
                    startDate: state.fabricPoMasterForm.startDate,
                    endDate: state.fabricPoMasterForm.endDate,
                    unitId: state.fabricPoMasterForm.unitId
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
